export default __webpack_public_path__ + "static/media/video2.d5ddf7e0.mp4";